import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useState } from "react";
import { FileButton } from "@mantine/core";
import { faFilePdf } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { FormSelect, FormTextarea } from "@/components/form";
import { useEmrContext } from "@/hooks/emr-context";
import { usePatientStudies } from "@/hooks/studies";
import { useLinkStudyToReport, useUploadReport } from "@/hooks/report";
import { useComposerStore } from "@/stores/composers";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { formatDate } from "@/utils/format";
import { ComposerShell } from "./composer-shell";
import { parsePdfText } from "./parse-pdf";
/** Report composer: PDF import, optional study link, and a real upload on send. */
export function ReportComposerBody(_ref) {
  var _studiesQuery$data$st, _studiesQuery$data;
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    workspaceId = _useEmrContext.workspaceId,
    patientUid = _useEmrContext.patientUid;
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var setContent = useComposerStore(function (state) {
    return state.setContent;
  });
  var _useState = useState(null),
    selectedStudy = _useState[0],
    setSelectedStudy = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(false),
    isParsing = _useState3[0],
    setIsParsing = _useState3[1];
  var studiesQuery = usePatientStudies(patientUid);
  var upload = useUploadReport(workspaceId, patientUid);
  var link = useLinkStudyToReport(workspaceId, patientUid);
  var isSending = upload.isLoading || link.isLoading;
  var studyOptions = ((_studiesQuery$data$st = (_studiesQuery$data = studiesQuery.data) === null || _studiesQuery$data === void 0 ? void 0 : _studiesQuery$data.studies) !== null && _studiesQuery$data$st !== void 0 ? _studiesQuery$data$st : []).map(function (study) {
    var _study$series, _study$radiologist_re;
    return {
      value: study.accession_number,
      label: "".concat(study.study_description || ((_study$series = study.series) === null || _study$series === void 0 || (_study$series = _study$series[0]) === null || _study$series === void 0 ? void 0 : _study$series.modality) || t("study", {
        defaultValue: "Study"
      }), " \xB7 ").concat(formatDate(study.created_at)),
      disabled: Boolean((_study$radiologist_re = study.radiologist_report) === null || _study$radiologist_re === void 0 ? void 0 : _study$radiologist_re.report)
    };
  });
  var importPdf = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
      var _t, _t2, _t3;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (file) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            trackEvent(ANALYTICS_EVENTS.REPORT_UPLOAD_PDF, {
              composerId: composer.id
            });
            setError(null);
            setIsParsing(true);
            _context.p = 2;
            _t = setContent;
            _t2 = composer.id;
            _context.n = 3;
            return parsePdfText(file);
          case 3:
            _t(_t2, _context.v);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t3 = _context.v;
            setError(t("report_pdf_failed", {
              defaultValue: "Could not read the PDF. Paste the text instead."
            }));
          case 5:
            _context.p = 5;
            setIsParsing(false);
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4, 5, 6]]);
    }));
    return function importPdf(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var send = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var report, _t4;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            setError(null);
            _context2.p = 1;
            _context2.n = 2;
            return upload.mutateAsync(composer.content);
          case 2:
            report = _context2.v;
            if (!selectedStudy) {
              _context2.n = 3;
              break;
            }
            _context2.n = 3;
            return link.mutateAsync({
              reportId: report.id,
              accessionNumber: selectedStudy
            });
          case 3:
            close(composer.id);
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t4 = _context2.v;
            setError(t("report_save_failed", {
              defaultValue: "Could not save the report. Please try again."
            }));
          case 5:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return function send() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: composer.title,
    subtitle: composer.subtitle,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      "data-testid": "composer-cancel-".concat(composer.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_CANCEL, {
          composerId: composer.id
        });
        close(composer.id);
      }
    }, t("cancel", {
      defaultValue: "Cancel"
    })), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "composer-save-".concat(composer.id),
      loading: isSending,
      disabled: !composer.content.trim(),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_SAVE, {
          composerId: composer.id
        });
        void send();
      }
    }, t("send_report", {
      defaultValue: "Send report"
    })))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement(FileButton, {
    accept: "application/pdf",
    onChange: function onChange(file) {
      return void importPdf(file);
    }
  }, function (props) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
      variant: "secondary",
      size: "sm",
      leftIcon: faFilePdf,
      loading: isParsing,
      "data-testid": "report-upload-pdf"
    }), t("upload_pdf", {
      defaultValue: "Upload PDF"
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement(FormSelect, {
    placeholder: t("link_study", {
      defaultValue: "Link a study (optional)"
    }),
    data: studyOptions,
    value: selectedStudy,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.REPORT_LINK_STUDY, {
        composerId: composer.id
      });
      setSelectedStudy(value);
    },
    clearable: true,
    searchable: true,
    withinPortal: true,
    nothingFound: t("no_study_available", {
      defaultValue: "No study available"
    }),
    disabled: studiesQuery.isLoading,
    "data-testid": "report-link-study"
  }))), /*#__PURE__*/React.createElement(FormTextarea, {
    label: t("report_text", {
      defaultValue: "Report"
    }),
    minRows: 10,
    placeholder: t("report_placeholder", {
      defaultValue: "Type or paste the report, or upload a PDF…"
    }),
    value: composer.content,
    onChange: function onChange(event) {
      return setContent(composer.id, event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.COMPOSER_CONTENT, {
        composerId: composer.id
      });
    },
    "data-testid": "composer-content-".concat(composer.id)
  }), error ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-urgent-secondary"
  }, error) : null));
}